/**
 * ViewPrepare Constants
 */

export const LOADER_STATUS = 'gstr9New/ViewPrepare/LOADER_STATUS';
export const SET_PREPARED_GSTR9_DATA = 'gstr9New/ViewPrepare/SET_PREPARED_GSTR9_DATA';
export const FETCH_PREPARED_DATA_REQUEST = 'gstr9New/ViewPrepare/FETCH_PREPARED_DATA_REQUEST';
export const FETCH_PREPARED_DATA_SUCCESS = 'gstr9New/ViewPrepare/FETCH_PREPARED_DATA_SUCCESS';
export const FETCH_PREPARED_DATA_FAILURE = 'gstr9New/ViewPrepare/FETCH_PREPARED_DATA_FAILURE';

// Auto Drafted Summary constants
export const SET_AUTODRAFTED_GSTR9_DATA = 'gstr9New/ViewPrepare/SET_AUTODRAFTED_GSTR9_DATA';
export const FETCH_AUTODRAFTED_DATA_REQUEST = 'gstr9New/ViewPrepare/FETCH_AUTODRAFTED_DATA_REQUEST';
export const FETCH_AUTODRAFTED_DATA_SUCCESS = 'gstr9New/ViewPrepare/FETCH_AUTODRAFTED_DATA_SUCCESS';
export const FETCH_AUTODRAFTED_DATA_FAILURE = 'gstr9New/ViewPrepare/FETCH_AUTODRAFTED_DATA_FAILURE';

// Reconciled Summary constants
export const SET_RECONCILED_GSTR9_DATA = 'gstr9New/ViewPrepare/SET_RECONCILED_GSTR9_DATA';
export const FETCH_RECONCILED_DATA_REQUEST = 'gstr9New/ViewPrepare/FETCH_RECONCILED_DATA_REQUEST';
export const FETCH_RECONCILED_DATA_SUCCESS = 'gstr9New/ViewPrepare/FETCH_RECONCILED_DATA_SUCCESS';
export const FETCH_RECONCILED_DATA_FAILURE = 'gstr9New/ViewPrepare/FETCH_RECONCILED_DATA_FAILURE';

// Prepare Summary constants
export const SET_PREPARE_GSTR9_DATA = 'gstr9New/ViewPrepare/SET_PREPARE_GSTR9_DATA';
export const FETCH_PREPARE_DATA_REQUEST = 'gstr9New/ViewPrepare/FETCH_PREPARE_DATA_REQUEST';
export const FETCH_PREPARE_DATA_SUCCESS = 'gstr9New/ViewPrepare/FETCH_PREPARE_DATA_SUCCESS';
export const FETCH_PREPARE_DATA_FAILURE = 'gstr9New/ViewPrepare/FETCH_PREPARE_DATA_FAILURE';

// Overwrite Auto Drafted Data constants
export const SET_OVERWRITE_DIALOG_DATA = 'gstr9New/ViewPrepare/SET_OVERWRITE_DIALOG_DATA';
export const SET_OVERWRITE_SUMMARY_DATA = 'gstr9New/ViewPrepare/SET_OVERWRITE_SUMMARY_DATA';
export const OVERWRITE_AUTO_DRAFTED_REQUEST = 'gstr9New/ViewPrepare/OVERWRITE_AUTO_DRAFTED_REQUEST';
export const OVERWRITE_AUTO_DRAFTED_SUCCESS = 'gstr9New/ViewPrepare/OVERWRITE_AUTO_DRAFTED_SUCCESS';
export const OVERWRITE_AUTO_DRAFTED_FAILURE = 'gstr9New/ViewPrepare/OVERWRITE_AUTO_DRAFTED_FAILURE';

export const SET_OVERRIDE_DATA = 'gstr9New/ViewPrepare/SET_OVERRIDE_DATA'; 

// Download Summary Report constants
export const DOWNLOAD_SUMMARY_REPORT_REQUEST = 'gstr9New/ViewPrepare/DOWNLOAD_SUMMARY_REPORT_REQUEST';
export const DOWNLOAD_SUMMARY_REPORT_SUCCESS = 'gstr9New/ViewPrepare/DOWNLOAD_SUMMARY_REPORT_SUCCESS';
export const DOWNLOAD_SUMMARY_REPORT_FAILURE = 'gstr9New/ViewPrepare/DOWNLOAD_SUMMARY_REPORT_FAILURE';

// Clear data constants
export const CLEAR_PREPARED_DATA = 'gstr9New/ViewPrepare/CLEAR_PREPARED_DATA';
export const CLEAR_AUTODRAFTED_DATA = 'gstr9New/ViewPrepare/CLEAR_AUTODRAFTED_DATA';
export const CLEAR_RECONCILED_DATA = 'gstr9New/ViewPrepare/CLEAR_RECONCILED_DATA';
export const CLEAR_PREPARE_DATA = 'gstr9New/ViewPrepare/CLEAR_PREPARE_DATA';
export const CLEAR_ALL_VIEW_PREPARE_DATA = 'gstr9New/ViewPrepare/CLEAR_ALL_VIEW_PREPARE_DATA';